export const MODULE_NAME = 'contractor';
export const ACCESS_NAME = 'Contractors';
